import styled from 'styled-components'
import Card from "../juegos/card.jsx"
import { useSelector,useDispatch } from 'react-redux'
import { modifcarShoppingCart } from '../../redux/actions/shoppingCartActions.js'
import CloseIcon from '@mui/icons-material/Close';


const Container=styled.div`
	border-bottom:1px solid #E3DEDE;
	height:100%;
	width:100%;
	display:flex;
	align-items:center;
	justify-content: space-around;
	border-radius:2px;
	margin:1px;
	&:hover{
		background-color:#F7F7F7
	}
	

`
const ContainerJuego=styled.div`
	width:30%;
	height:75%;
	position:relative;
`

const ContainerJuegoDelete=styled.div`
	position:absolute;
	font-weight:bold;
	background-color:white;
	font-size:10px;
	height:17px;
	width:17px;
	border-radius:150px;
	display:flex;
	justify-content:center;
	align-items:center;
	right:-9px;
	top:-8px;
	box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);

`

const ContainerDetalleJuego=styled.div`
	height:80%;
	width:50%;
	position:relative;
	display:flex;
	justify-content:end
;`
const JuegoNombre=styled.div`
	font-size:13px;
	font-weight:bold;
	text-align:right
`;

const JuegoPrecio=styled.div`
	font-size:13px;
	position:absolute;
	bottom:1px
	
	
`;


export default function ShoppingCardElement(props){
	let  {reventa}=props;
	let pais=useSelector(state=>state.pais.pais);
	let shoppingCart  = useSelector(state=>state.shoppingCart.reventas);
	let dispatch=useDispatch();


	const eliminar=()=>{
		let nuevoShopinngCart=shoppingCart.filter(ele=>ele.id!==reventa.id);
		dispatch(modifcarShoppingCart(nuevoShopinngCart))

	}
	return(
		<Container>
			<ContainerJuego>
				<Card consola={reventa.consola} poster={reventa.Cuenta_Juego.Juego.poster} />
				<ContainerJuegoDelete onClick={eliminar}><CloseIcon  sx={{fontSize:"10px"}}/> </ContainerJuegoDelete>
			</ContainerJuego>
			<ContainerDetalleJuego>
				<JuegoNombre>{reventa.Cuenta_Juego.Juego.nombre.toUpperCase()}</JuegoNombre>
				<JuegoPrecio>{pais.modenaIcono +" "+reventa[`precio_${pais.nombre}`]+" "+pais.moneda}</JuegoPrecio>
			</ContainerDetalleJuego>
			
		</Container>
		)
}